export default "<app-report-table>\n    [table]=\"table$\"\n</app-report-table>\n"